import type { AnyItem } from '#layers/data-model';

/**
 * Converts a nested object into bracket notation for URL query parameters (e.g., `filter[_eq]=value`)
 */
export function stringifyQuery(obj: AnyItem) {
	const fields: Record<string, string> = {};

	function generateIndexSyntaxRecursive(obj: AnyItem, path?: string) {
		for (const key in obj) {
			const value = obj[key];
			const indexKey = path ? `${path}[${key}]` : key;

			if (value != null) {
				if (typeof value === 'object') {
					generateIndexSyntaxRecursive(value, indexKey);
				}
				else {
					fields[indexKey] = value;
				}
			}
		}
	}

	generateIndexSyntaxRecursive(obj);

	return fields;
}
